import { httpClient } from "../http-client";
import { NEW_API_ENDPOINTS } from "../../../shared/constants/api";
import type {
  ApiResponseRouterEntity, ApiResponseRouterEntityList,
  CreateRouterRequest
} from "../../../shared/types/api";

export class AdminRouterService {
  async getRouters(
    companyId: number,
  ): Promise<ApiResponseRouterEntityList> {
    const response = await httpClient.get<ApiResponseRouterEntityList>(
      NEW_API_ENDPOINTS.adminRouterController.GET(companyId),
    );

    if (response.data.errorCode) {
      throw new Error(response.data.errorMsg || "라우터 불러오기 실패.");
    }

    return response.data;
  }

  async createRouter(
    companyId: number,
    request: CreateRouterRequest,
  ): Promise<ApiResponseRouterEntity> {
    const response = await httpClient.post<ApiResponseRouterEntity>(
      NEW_API_ENDPOINTS.adminRouterController.POST(companyId),
      request,
    );

    if (response.data.errorCode) {
      throw new Error(response.data.errorMsg || "라우터 생성 실패.");
    }

    return response.data;
  }
}

export const adminRouterService = new AdminRouterService();
